import { useReviewCheckToggleContext } from '#baseMenu/components';
import { useAdvertReviewCheckVisibleControl } from '#reviewCheck/hooks';

const useReviewCheckHandlerClick = () => {
  const {
    isOpen: isOpenReviewCheck,
    open,
    hide,
  } = useAdvertReviewCheckVisibleControl();
  const {
    ReviewCheck,
    isLoaded,
    setIsLoaded,
    setIsLoadInProcess,
  } = useReviewCheckToggleContext();

  return () => {
    if (!isLoaded) {
      setIsLoadInProcess(true);
      ReviewCheck.load().then(() => {
        setIsLoaded(true);
        setIsLoadInProcess(false);
        open();
      });
      return;
    }

    if (isOpenReviewCheck) {
      hide();
    } else {
      open();
    }
  };
};

export { useReviewCheckHandlerClick };
